import React from "react";
import "./NotFound.css";

export default function NotFound() {
  return (
    <div className="text-center NotFound">
      <h3>Sorry, page not found!</h3>
    </div>
  );
}
